'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetMarketRow } from '@morfi/backend-sdk-v2/client';
import { UserAvatar } from '@/components/images/user-avatar';
export interface MarketIdentityData {
  marketType?: GetMarketRow['marketType'] | undefined;
  associatedCreator?: GetMarketRow['associatedCreator'] | undefined;
  partnerCreatorId?: GetMarketRow['partnerCreatorId'] | undefined;
}
export function CreatorIdentityAvatar(t0) {
  const $ = _c(3);
  const {
    identity,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const creator = identity.associatedCreator;
  let t2;
  if ($[0] !== creator || $[1] !== size) {
    t2 = creator ? <UserAvatar size={size} userId={creator.userId ?? creator.walletAddress} displayName={creator.displayName} avatarUrl={creator.avatarUrl} nsfw={creator.avatarNsfw === true} rasterise={creator.avatarPreferences?.rasterise ?? false} /> : null;
    $[0] = creator;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}